import { db } from "../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  doc,
} from "firebase/firestore";
import { EmailSenderBase } from "../utils/EmailSenderBase";
import { format } from "date-fns";
import ja from "date-fns/locale/ja";

export const JointEvent = async (
  event,
  eventId,
  events,
  eventdate,
  participantCounts,
  membersList,
  setEventMembers,
  setUserEventParticipation,
  setResponseMessage = () => {}, // 呼び出し元で渡されなくてもエラーにならない
  currentUserInfo,
  currentUser,
  navigate
) => {
  try {
    console.log("JointEvent: 開始", { eventId, userId: currentUser?.uid });

    const userId = currentUser?.uid;
    if (!userId) {
      throw new Error("ユーザーが認証されていません");
    }

    const useradmin = currentUserInfo?.admin ?? false;
    const useradministrator = currentUserInfo?.administrator ?? false;

    // 既に参加しているかチェック
    const eventMembersQuery = query(
      collection(db, "event_members"),
      where("eventId", "==", eventId),
      where("memberId", "==", userId)
    );

    const querySnapshot = await getDocs(eventMembersQuery);
    if (!querySnapshot.empty) {
      alert("このイベントにはすでに参加しています。");
      return;
    }

    // イベント詳細を取得
    const eventDetail = events.find((e) => e.id === eventId);
    if (!eventDetail) {
      alert("イベントが見つかりません");
      return;
    }

    const currentParticipantsCount = participantCounts[eventId] || 0;
    if (currentParticipantsCount >= eventDetail.capacity) {
      alert("定員締め切りのため、参加できません。");
      return;
    }

    // メンバー情報チェック
    const user = membersList.find((member) => member.author?.id === userId);
    if (!user) {
      alert(
        "あなたはメンバー名が未登録です。メンバー登録でお名前を登録してください。"
      );
      navigate("/member");
      return;
    }
    const accountname = user.accountname;

    // 参加登録（event_membersコレクション）
    const docRef = await addDoc(collection(db, "event_members"), {
      eventId,
      memberId: userId,
      accountname,
      eventdate,
      ad: useradmin,
      admi: useradministrator,
      created_at: new Date(),
      updated_at: new Date(),
    });

    // eventsコレクション内のサブコレクションにも登録
    await addDoc(collection(doc(db, "events", eventId), "members"), {
      memberId: userId,
      accountname,
      eventdate,
      useradmin,
      useradministrator,
      created_at: new Date(),
      updated_at: new Date(),
    });

    // ── 2週間前かどうかの判定 ────────────────────────────────
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // starttime が文字列の場合も安全に扱う
    let startTimeDate;
    if (typeof event.starttime === "string") {
      startTimeDate = new Date(event.starttime);
    } else if (event.starttime instanceof Date) {
      startTimeDate = event.starttime;
    } else {
      console.warn("starttime の形式が不明:", event.starttime);
      startTimeDate = new Date(); // フォールバック
    }

    if (isNaN(startTimeDate.getTime())) {
      console.error("無効な日付形式:", event.starttime);
      startTimeDate = new Date();
    }

    startTimeDate.setHours(0, 0, 0, 0);
    const diffInDays = Math.floor(
      (startTimeDate - today) / (1000 * 60 * 60 * 24)
    );
    const isWithinTwoWeeks = diffInDays <= 14;

    // 2週間以内の場合に管理者へ通知メール
    if (isWithinTwoWeeks) {
      console.log("2週間以内のイベント → 通知メール送信");

      const subject = "二週間前より以降の参加表明";

      const emailText = `二週間前より以降の${format(
        startTimeDate,
        "M/d（E）HH:mm",
        { locale: ja }
      )}の${event.title}参加表明が${
        currentUserInfo?.accountname || "不明"
      }さんからありましたので、テニスオフの募集調整等の対応をしてください。\n\nhttps://raising2024-7e234.web.app/eventdetail/${eventId}`;

      try {
        await EmailSenderBase(
          "matsumo33333@gmail.com",
          subject,
          emailText,
          setResponseMessage
        );
        console.log("管理者通知メール送信成功");
        alert("参加申し込みの連絡メールが送信されました。");
      } catch (mailError) {
        console.error("管理者通知メール送信失敗:", mailError);
        alert(
          "参加登録は完了しましたが、管理者への通知メール送信に失敗しました。"
        );
      }
    } else {
      console.log("2週間以上先のイベント → メール送信不要");
    }

    // ── 状態更新 ───────────────────────────────────────────────
    const docId = docRef.id;

    // 即時反映のためのローカル更新
    setEventMembers((prev) => [
      ...prev,
      { eventId, memberId: userId, accountname, id: docId },
    ]);

    setUserEventParticipation((prev) => ({
      ...prev,
      [eventId]: true,
    }));

    // 全件再取得（パフォーマンスが気になる場合はコメントアウト推奨）
    try {
      const eventMembersSnapshot = await getDocs(
        collection(db, "event_members")
      );
      const eventMembersList = eventMembersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setEventMembers(eventMembersList);
    } catch (refetchError) {
      console.warn(
        "event_members 全件再取得失敗（ローカル更新のみで続行）:",
        refetchError
      );
    }

    console.log("JointEvent: 完了");
  } catch (error) {
    console.error("JointEvent 全体エラー:", error);
    alert(
      "参加処理中にエラーが発生しました。\n" + (error.message || "詳細不明")
    );
  }
};
